//#region src/engine/modules/table/actions.ts
var ActionType = {
	addTable: "table.add",
	moveTable: "table.move",
	moveToTable: "table.moveTo",
	removeTable: "table.remove",
	changeTableName: "table.changeName",
	changeTableComment: "table.changeComment",
	changeTableColor: "table.changeColor",
	changeTableGroup: "table.changeGroup",
	changeZIndex: "table.changeZIndex",
	sortTable: "table.sort",
	changeTableLogicalName: "table.changeLogicalName",
	changeTableNameDerived: "table.changeNameDerived"
};
//#endregion
export { ActionType };
